<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import OrganizationalUnitListItem from './components/OrganizationalUnitListItem';
import NewOrganizationalUnitDialog from './components/NewOrganizationalUnitDialog';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'OrganizationalUnitList',
  components: {
    OrganizationalUnitListItem,
    NewOrganizationalUnitDialog,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Name', value: 'name' }, { text: 'Gelöscht', value: 'isDelete' }, { text: 'Aktionen', value: '', sortable: false }],
      isDeleteOptions: [{ id: null, text: 'alle' }, { id: true, text: 'ja' }, { id: false, text: 'nein' }],
      showNewOrganizationalUnitDialog: false,
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      unitToDelete: {},
      isDeleteFilter: false,
    };
  },
  computed: {
    ...mapState(['organizationalUnitList']),
    ...mapState('organizationalUnitList', ['data', 'meta', 'isLoading', 'hasError']),
    filteredItems() {
      const self = this;

      if (!this.data) return [];
      if (this.isDeleteFilter == null) return this.data;

      return this.data.filter(it => it.isDelete === self.isDeleteFilter);
    },
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('organizationalUnitList', ['fetchOrganizationalUnitList']),
    ...mapActions('organizationalUnitList', { deleteOrganizationalUnit: 'deleteOrganizationalUnit' }),
    fetchData(options) {
      return this.fetchOrganizationalUnitList(options);
    },
    onDelete(unitToDelete) {
      this.unitToDelete = unitToDelete;
      this.confirmDeletionMessage =
        `Soll die Organisationseinheit ${this.unitToDelete.name} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.deleteOrganizationalUnit(this.unitToDelete)
        .then(() => {
          this.fetchData().then(() => {
            this.isInitialized = true;
          });
          this.isConfirmDialogDisplayed = false;
        });
    },
  },
};
</script>

<template>
  <div class="organizationalUnit-list">
    <template v-if="organizationalUnitList.hasError">
      <p class="js-error-template ma-3">
        Failed to fetch organizational unit list. Please try again!
      </p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewOrganizationalUnitDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Hinzufügen</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="fetchData(paginationParams)" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>
      </v-toolbar>

      <v-flex xs4 md2>
        <v-select
          style="padding-left: 22px; padding-top: 25px;"
          :items="isDeleteOptions"
          v-model="isDeleteFilter"
          item-value="id"
          item-text="text"
          label="Gelöscht" />
      </v-flex>

      <v-progress-linear
        v-if="organizationalUnitList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="filteredItems"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="organizationalUnitList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable',
                       pagination.descending ? 'desc' : 'asc',
                       header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value, filteredItems)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <organizationalUnit-list-item
            :organizational-unit="props.item"
            :expanded="props.expanded"
            @delete="onDelete"
          />
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>

      <NewOrganizationalUnitDialog
        v-if="showNewOrganizationalUnitDialog"
        @cancel="showNewOrganizationalUnitDialog = false"
      />

      <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                          :message="confirmDeletionMessage"
                          :is-displayed="isConfirmDialogDisplayed" />

    </template>
  </div>
</template>

<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
